export * from './actions';
export * from './effects';
export * from './service';

export {
  featureKey as homeRegimeKey,
  initialState as homeRegimeInitialState,
  State as HomeRegimeState,
} from './reducer';

export {
  getData as homeRegimeGetData,
  getError as homeRegimeGetError,
  getLoading as homeRegimeGetLoading,
  mapData as homeRegimeMapData,
} from './selectors';
